import { Button } from "$components/button/button";
import { useRxDBContext } from "$global-providers/rxdb-provider/provider";
import { UnsavedDataConfirmationDialog } from "$routes/_lib/layout/unsaved-data-confirmation-dialog";
import { linkToSignOut } from "$routes/_lib/links";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  h1: {
    textAlign: "center",
  },
  messageWrapper: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    textAlign: "center",
    display: "inline-block",
  },
  message: {
    fontSize: 15,
    color: theme.palette.grey[400],
    paddingBottom: 20,
  },
  root: {
    minHeight: theme.spacing(12),
    flex: 1,
    flexDirection: "column",
  },
}));

export const Content: FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    replicationState: { hasUnsyncedChanges },
  } = useRxDBContext();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleSignInClick = () => {
    if (hasUnsyncedChanges) {
      setShowConfirmDialog(true);
    } else {
      navigate(linkToSignOut());
    }
  };

  const handleConfirmSignIn = () => {
    setShowConfirmDialog(false);
    navigate(linkToSignOut());
  };

  const handleCancelSignIn = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <Grid
        className={classes.root}
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Typography
          variant="h4"
          component="h1"
          className={classes.h1}
          color="inherit"
        >
          <FormattedMessage
            id="unauthorized.title"
            defaultMessage="You're not authorised to view this page"
          />
        </Typography>
        <div className={classes.messageWrapper}>
          <Typography
            variant="h4"
            component="h4"
            className={classes.message}
            color="inherit"
          >
            {/* TODO: Add error code */}
            <FormattedMessage
              id="unauthorized.errorCode"
              defaultMessage="Error Code: XXX"
            />
          </Typography>
          <Typography
            variant="h4"
            component="h4"
            className={classes.message}
            color="inherit"
          >
            <FormattedMessage
              id="unauthorized.message"
              defaultMessage="Sign in or return to the homepage"
            />
          </Typography>
        </div>
        <Button variant="contained" color="primary" onClick={handleSignInClick}>
          <FormattedMessage
            id="unauthorized.logoutBtn"
            defaultMessage="Sign in"
          />
        </Button>
      </Grid>
      <UnsavedDataConfirmationDialog
        open={showConfirmDialog}
        onConfirm={handleConfirmSignIn}
        onCancel={handleCancelSignIn}
      />
    </>
  );
};
